var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-layout",style:(_vm.layoutStyle),attrs:{"id":"screen-layout"}},[_c('div',{staticClass:"screen-container",style:(_vm.containerStyle)},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }